import { render } from "./Projections.vue?vue&type=template&id=17d70814"
import script from "./Projections.vue?vue&type=script&lang=js"
export * from "./Projections.vue?vue&type=script&lang=js"

import "./Projections.vue?vue&type=style&index=0&id=17d70814&lang=css"

import exportComponent from "/github/workspace/ff-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__